import { compareNodePosition } from './dom';
import { KeyPath } from 'app/models/entityStateSync/keypath';
import { is, Map } from 'immutable';

export interface INodePoint {
  readonly path: KeyPath;
  readonly node: HTMLElement;
  readonly block: boolean;
}

export default class LazySortedNodes {
  private nodes: INodePoint[] = [];
  private index = Map<KeyPath, INodePoint>();
  private dirty = false;

  public add(node: INodePoint) {
    this.dirty = true;
    this.nodes.push(node);
    this.index = this.index.set(node.path, node);
  }

  public remove(path: KeyPath) {
    const i = this.nodes.findIndex(({ path: nodePath }) => is(path, nodePath));
    if (i >= 0) {
      this.nodes.splice(i, 1);
    }
    this.index = this.index.delete(path);
  }

  public getNodes(): readonly INodePoint[] {
    if (this.dirty) {
      this.nodes.sort(({ node: a }, { node: b }) => compareNodePosition(a, b));

      this.dirty = false;
    }

    return this.nodes;
  }

  public getIndex(): Map<KeyPath, INodePoint> {
    return this.index;
  }

  public clear() {
    this.nodes = [];
    this.index = Map();
  }
}
